import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export async function addressPrivacy(
  addressId: number,
  // payload: any,
  token: string,
  t: (key: string) => string
): Promise<any> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }


  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/api/Address/ToggleIsPrivate`,

      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ addressId }),
      }
    );


    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Failed to update address privacy: ${errorData.message}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    // console.error("Error updating address privacy:", error);
    throw error;
  }
}
